import { render } from "./TheVehiclesContainer.vue?vue&type=template&id=01249b32"
import script from "./TheVehiclesContainer.vue?vue&type=script&lang=js"
export * from "./TheVehiclesContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__